import React, { useContext, useMemo } from "react";
import { TranslationContext } from "../../hooks/useTranslationContext";
export function Pagination(_a) {
    var children = _a.children, gotoPage = _a.gotoPage, canPreviousPage = _a.canPreviousPage, previousPage = _a.previousPage, nextPage = _a.nextPage, canNextPage = _a.canNextPage, pageCount = _a.pageCount, pageIndex = _a.pageIndex, pageOptions = _a.pageOptions, pageSize = _a.pageSize, setPageSize = _a.setPageSize;
    var t = useContext(TranslationContext);
    var floatingChildren = useMemo(function () {
        if (!React.Children.count(children)) {
            return false;
        }
        return React.createElement("span", { className: "float-right" }, children);
    }, [children]);
    return (React.createElement("div", { className: "pagination" },
        React.createElement("button", { onClick: function () { return gotoPage(0); }, disabled: !canPreviousPage }, '<<'),
        ' ',
        React.createElement("button", { onClick: function () { return previousPage(); }, disabled: !canPreviousPage }, '<'),
        ' ',
        React.createElement("button", { onClick: function () { return nextPage(); }, disabled: !canNextPage }, '>'),
        ' ',
        React.createElement("button", { onClick: function () { return gotoPage(pageCount - 1); }, disabled: !canNextPage }, '>>'),
        ' ',
        React.createElement("span", null,
            t("general.page"),
            ' ',
            React.createElement("strong", null,
                pageIndex + 1,
                " of ",
                pageOptions.length),
            ' '),
        React.createElement("span", null,
            "| ",
            t("general.go_to_page"),
            ' ',
            React.createElement("input", { type: "number", defaultValue: pageIndex + 1, onChange: function (e) {
                    var page = e.target.value ? Number(e.target.value) - 1 : 0;
                    gotoPage(page);
                }, style: { width: '100px' } })),
        ' ',
        React.createElement("select", { value: pageSize, onChange: function (e) {
                setPageSize(Number(e.target.value));
            } }, [10, 20, 30, 40, 50].map(function (pageSize) { return (React.createElement("option", { key: pageSize, value: pageSize }, t("general.show__", { pageSize: pageSize }))); })),
        floatingChildren));
}
